<template>
  <div class="home-container">
    <div class="button-grid">
      <div
        v-for="(button, index) in buttons"
        :key="`${this.$router.currentRoute.value.name}-${index}`"
        class="button"
        @click="goTo(button.route)"
        :style="{
          animationDelay: `${index * 0.1}s`,
          animationDuration: `${0.4 + index * 0.05}s`,
          backgroundColor: button.color || 'var(--primary-color)',
          color: button.textColor || 'white',
        }"
      >
        <span>{{ button.text }}</span>
      </div>
    </div>
    <div class="lang-selector" @click="handleLangChange()">
      {{ displayText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  props: {
    buttons: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      displayText: "not set",
    };
  },
  mounted() {
    // Determine the current language from localStorage or route params
    const savedLang = localStorage.getItem("selectedLang");
    const routeLang = this.$router.currentRoute.value.params.lang;
    var currentLang = "fr";
    if (savedLang) {
      currentLang = savedLang;
    } else if (routeLang) {
      currentLang = routeLang;
    }
    localStorage.setItem("selectedLang", currentLang);

    // Set the display text to the opposite language
    const otherLang = currentLang === "fr" ? "de" : "fr";
    this.displayText = otherLang.toUpperCase();

    // If the route does not have a lang param, set it and reload the page with the correct language parameter
    if (!routeLang) {
      this.$router.push({
        name: this.$router.currentRoute.value.name,
        params: {
          ...this.$router.currentRoute.value.params,
          lang: savedLang || "fr",
        },
      });
      return;
    }
  },
  methods: {
    goTo(route) {
      if (route.name === "site") {
        window.location.href = route.query.url;
      } else {
        this.$router.push(route);
      }
    },
    handleLangChange() {
      const currentLang = localStorage.getItem("selectedLang");
      // Change the display text to the current language so it's the opposite language after navigation
      this.displayText = currentLang.toUpperCase();
      const newLang = currentLang === "fr" ? "de" : "fr";
      localStorage.setItem("selectedLang", newLang);
      this.$router.push({
        name: this.$router.currentRoute.value.name,
        params: { ...this.$router.currentRoute.value.params, lang: newLang },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: $background-color;
  background-size: cover;
}

.button-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2vh;
}

@media (orientation: landscape) {
  .button-grid {
    display: grid;
    grid-template-columns: unset;
    grid-template-rows: unset;
    grid-auto-flow: line;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr 1fr;
  }
}

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30vw;
  max-width: 30vh;
  height: 30vw;
  max-height: 30vh;
  color: $secondary-color;
  font-size: 1.5em;
  font-weight: lighter;
  font-family: "Bw Quinta Pro Bold", sans-serif;
  cursor: pointer;
  border-radius: 10px;
  transform: scale(0);
  animation-name: pop;
  animation-fill-mode: forwards;
  transition: background-color 0.3s ease;
}

.button:hover {
  background-color: #2980b9;
}

.button span {
  text-align: center;
  padding: 1em;
}

.lang-selector {
  color: $secondary-color;
  font-size: 2.5em;
  font-family: "Bw Quinta Pro Bold", sans-serif;
  position: absolute;
  top: 5vh;
  right: 5vh;
}

/* Animation de pop */
@keyframes pop {
  0% {
    opacity: 0;
    transform: scale(0);
  }

  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
